import React from 'react';
import {Modal, Button} from 'antd';

interface ModalProps {
	isVisible: boolean;
	onClose: () => void;
	title: string;
	content: string;
	modalType: 'success' | 'error';
}

const SuccessOrErrorModal: React.FC<ModalProps> = ({isVisible, onClose, title, content, modalType}) => {
	return (
		<Modal open={isVisible} onCancel={onClose} footer={null} title={title} centered>
			<p>{content}</p>
			<div style={{textAlign: 'center', marginTop: '20px'}}>
				<Button
					type="primary"
					style={{
						backgroundColor: modalType === 'success' ? 'green' : 'red',
						borderColor: modalType === 'success' ? 'green' : 'red'
					}}
					onClick={onClose}>
					{modalType === 'success' ? 'Done' : 'Close'}
				</Button>
			</div>
		</Modal>
	);
};

export default SuccessOrErrorModal;
